import { CmsPageContentIdentifier } from '@/types/fitting-hardware';

export const initialState = {
  cmsContent: {
    [CmsPageContentIdentifier.Title]: '',
    [CmsPageContentIdentifier.HighlightText]: '',
    [CmsPageContentIdentifier.ActivationFeeText]: '',
    [CmsPageContentIdentifier.BuyHardwareTeaser]: '',
  },
  hardwareOptions: [],
  hardwareSelectionHint: '',
};

export default initialState;
